/**
 * The types of quick links.
 *
 * @class QuickLinksTypes
 * @name types
 * @memberof Mojito.Modules.QuickLinks
 */

/**
 * Supported notifications.
 *
 * @readonly
 * @enum {string}
 * @memberof Mojito.Modules.QuickLinks.types
 */
const NOTIFICATIONS = {
    HAS_OPEN_BETS: 'hasOpenBets',
};

export default { NOTIFICATIONS };
